import { cssVar, localeIRNumberFormatter } from '@zoomit/primitives';
import { theme, Typography } from '@zoomit/zoomit-ds';

export const ProductPrice = ({ price }: { price: number }) => {
  return price === 0 ? (
    <Typography tag="span" fontWeight="bold" fontSize={1.4} lineHeight={2} textColor={cssVar(theme.grey1)}>
      ناموجود
    </Typography>
  ) : (
    <Typography variant="callout" textAlign="right">
      <Typography variant="h5" className="fa" tag="span">
        {localeIRNumberFormatter(price)}
      </Typography>{' '}
      تومان
    </Typography>
  );
};
